import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import './registerServiceWorker'
import axios from 'axios'
import VeeValidate from 'vee-validate';
// import _ from 'lodash'npm 
// import Toasted from 'vue-toasted';
import Buefy from 'buefy';
import Toasted from 'vue-toasted';
import VTooltip from 'v-tooltip'
import Spinner from 'vue-simple-spinner'
import Requestname from '@/components/Requestname.vue'
import Requeststatus from '@/components/Requeststatus.vue'
import Requesthistory from '@/components/Requesthistory.vue'
import moment from "moment";

Vue.use(VTooltip)


window.Event = new Vue();
// import {  HalfCircleSpinner } from 'epic-spinners'
import 'buefy/dist/buefy.css'
require('bulma-rtl/css/bulma-rtl.css');
require('./assets/css/wahdagreen.css');
require('./assets/css/icons.min.css');
// // // // // require('./assets/css/bulma-rtl.css')
require('./assets/css/core_islamicgreen.css');


import VCalendar from 'v-calendar';
require('./assets/css/vcalander.css');


// Use v-calendar, v-date-picker & v-popover components
Vue.use(VCalendar, {
  firstDayOfWeek: 1, // Monday              
  locale: "ar",
  popoverVisibility: 'focus',
});

// var devUrl = "http://localhost:7878/v1/";


// var prodUrl = process.env.VUE_APP_API_BASE_URL_PRODUCTION;

var prodUrl = process.env.VUE_APP_API_BASE_URL;


var apiUrl = prodUrl;

window.axios = axios

axios.defaults.headers.post["Content-Type"] = "application/json";
window.axios.defaults.headers.common['Authorization'] = window.token;
window.axios.defaults.headers.common['scope'] = window.scope;
window.axios.defaults.baseURL = apiUrl;

// window.axios.defaults.params={api_token:window.token};


Vue.mixin({
  methods: {
    kick(response) {
      if (response == "You do not have permission to perform the selected operation") {
        localStorage.removeItem("token");
        Event.$emit("logout");
        this.$router.push("/login");
      }
    },
    dateformat(date) {
      if (date != null)
        return moment(date).format("YYYY-MM-DD");
      else
        return null;
    },
  }
})



import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-rtl/3.4.0/css/bootstrap-rtl.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(VueHtmlToPaper, options);


const DEFAULT_TITLE = "SaharaOnline - الصحارى أونلاين";
Vue.config.productionTip = false
Vue.use(VeeValidate);
Vue.use(Buefy);
Vue.use(Toasted);



router.beforeEach((to, from, next) => {
  document.title = to.meta.title || DEFAULT_TITLE;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        path: '/',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      let user = JSON.parse(localStorage.getItem('user'));
      if (user && to.name !== 'terms' && to.name !== 'logout') {
        let isAgreed = localStorage.getItem('isAgreeOnTerms');
        if (isAgreed === 'true') {
          next();
        } else if (isAgreed === 'false') {
          next('/terms');
        } else {
          let token = localStorage.getItem('token');
          axios.get("/customer/basicData/" + user[1], { headers: { 'Authorization': token } })
            .then(response => {
              let agreed = response.data.result.IsAgreeOnTerms;
              if (agreed === false || agreed === 0) {
                localStorage.setItem('isAgreeOnTerms', 'false');
                next('/terms');
              } else {
                localStorage.setItem('isAgreeOnTerms', 'true');
                next();
              }
            }).catch(() => next());
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (localStorage.getItem('token') != null) {
      next({
        path: '/portal',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})


Vue.component('loading', Spinner);
Vue.component('name', Requestname);
Vue.component('status', Requeststatus);
Vue.component('history', Requesthistory);



new Vue({
  router,
  render: h => h(App)
}).$mount('#app')